import { Button } from 'antd';
import React, { useRef, useState } from 'react'
import { ReactSketchCanvas } from 'react-sketch-canvas';
import { Cropper } from 'react-advanced-cropper'
import 'react-advanced-cropper/dist/style.css';

const styles = {
  border: '0.0625rem solid #9c9c9c',
  borderRadius: '0.25rem',
};


export default function Imzo() {

    let canva = useRef(null)
    const [inlineResult, setInlineResult] = useState();
    const [imgSource, setImgSource] = useState();


    const onChange = (cropper) => {
        // console.log(cropper.getCoordinates(), cropper.getCanvas());
    };
  return (
      <div className='h-full'>
      {
            !imgSource ?  <>
            <ReactSketchCanvas
            style={styles}
            ref={canva}
            width="600"
            height="100vh"
            strokeWidth={2}
            // 133E87
            strokeColor={"#133E87"}
            /> 
            <div className='absolute top-0'>
    <Button onClick={() => {
        canva.current
        .exportImage("png")
        .then(data => {
            setImgSource(data)
          console.log(data);
        })
        .catch(e => {
          console.log(e);
        })
    }}>img</Button>
    <Button>save</Button>
    <Button onClick={() => {
        canva.current.clearCanvas()
    }}>del</Button>
  </div>
            </>
            : <></>
        }
       
  
  <div>
      {
        imgSource ?  <div className="h-80vh " >
        <Cropper
            onChange={onChange}
            className={'cropper'}
            src={"https://images.pexels.com/photos/326281/pexels-photo-326281.jpeg"}
           
        />

        {inlineResult && <img src={inlineResult} alt="" />}
    </div> : <></>
      }
  </div>
  </div>
  )
}
